import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketGuard } from './account-recovery/guards/ticket.guard';
import { CustomPreloadingStrategy } from './app.loading';
import { AuthGuard } from './auth/guards/auth.guards';
import { LockerLiteGuard } from './guards/lockerlite.guard';
import { OtpGuard } from './guards/otp.guard';
import { PropertySearchWidgetGuard } from './guards/property-search-widget.guard';
import { AccountRedirectComponent } from './shared-components/components/account-redirect/account-redirect.component';
import { FeatureCode } from './shared-enums/feature-code.enum';

const routes: Routes = [
    { path: 'account-recovery', loadChildren: () => import('./account-recovery/account-recovery.module').then(m => m.AccountRecoveryModule), canActivate: [TicketGuard] },
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    { path: 'deeplink', loadChildren: () => import('./deep-link/deep-link.module').then(m => m.DeepLinkModule) },
    { path: 'feedback', loadChildren: () => import('./feedback/feedback.module').then(m => m.FeedbackModule) },
    { path: 'fiserv-webhook', loadChildren: () => import('./fiserv-webhooks/fiserv-webhooks.module').then(m => m.FiservWebhooksModule) },
    { path: 'login', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    { path: 'market-report', loadChildren: () => import('./market-report/market-report.module').then(m => m.MarketReportModule) },
    {
        path: 'objective',
        canActivate: [AuthGuard],
        children: [
            { path: '', loadChildren: () => import('./objective/objective.module').then(m => m.ObjectiveModule), canActivate: [OtpGuard] }
        ]
    },
    { path: 'redirect', component: AccountRedirectComponent },
    { path: 'registration', loadChildren: () => import('./registration-3/registration.module').then(m => m.RegistrationModule) },
    { path: 'registration/invite', loadChildren: () => import('./registration-3/registration.module').then(m => m.RegistrationModule) },
    { path: 'registration/assetverification', loadChildren: () => import('./registration-3/registration.module').then(m => m.RegistrationModule) },
    {
        path: 'verification-service',
        loadChildren: () => import('./verification-service/verification-service.module').then(m => m.VerificationServiceModule),
        canActivate: [OtpGuard, LockerLiteGuard],
        data: {
            feature: FeatureCode[FeatureCode.VerificationService],
            url: 'dashboard'
        }
    },
    { path: 'properties/property-search-widget', loadComponent: () => import('./properties/components/properties-search-widget/properties-search-widget.component').then(m => m.PropertiesSearchWidgetComponent), canActivate: [PropertySearchWidgetGuard] },
    { path: '', loadChildren: () => import('./nav/nav.module').then(m => m.NavModule), data: { preload: false } },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    providers: [],
    declarations: [],
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', enableTracing: false, preloadingStrategy: CustomPreloadingStrategy })
    ],
    exports: [
        RouterModule
    ],
    bootstrap: [],
    schemas: []
})
export class AppRoutingModule { }
